import { supabase } from '@/lib/supabase';
import { createLogger } from '@/lib/logger';

const log = createLogger('APPLYGYMCONTEXT');

type GymContextInput = {
  id: string;
  name?: string | null;
  address?: string | null;
  place_id?: string | null;
  google_place_id?: string | null;
  lat?: number | null;
  lng?: number | null;
  latitude?: number | null;
  longitude?: number | null;
};

export async function applyGymContext(userId: string, gym: GymContextInput) {
  const { error: membershipError } = await supabase
    .from('gym_memberships')
    .upsert(
      {
        gym_id: gym.id,
        user_id: userId,
        role: 'member',
        status: 'active',
      },
      {
        onConflict: 'gym_id,user_id',
        ignoreDuplicates: false,
      }
    );

  if (membershipError) {
    log.error('[applyGymContext] gym_memberships upsert failed', {
      columns: ['gym_id', 'user_id', 'role', 'status'],
      message: membershipError.message,
    });
    throw membershipError;
  }

  const homeGymLat = gym.lat ?? gym.latitude ?? null;
  const homeGymLng = gym.lng ?? gym.longitude ?? null;

  const { error: updateError } = await supabase
    .from('profiles')
    .update({
      gym_id: gym.id,
      home_gym_id: gym.id,
      home_gym_name: gym.name ?? null,
      home_gym_place_id: gym.place_id ?? gym.google_place_id ?? null,
      home_gym_address: gym.address ?? null,
      home_gym_lat: homeGymLat,
      home_gym_lng: homeGymLng,
      home_gym_skipped: false,
    })
    .eq('id', userId);

  if (updateError) {
    log.error('[applyGymContext] profile update failed', {
      columns: [
        'gym_id',
        'home_gym_id',
        'home_gym_name',
        'home_gym_place_id',
        'home_gym_address',
        'home_gym_lat',
        'home_gym_lng',
        'home_gym_skipped',
      ],
      message: updateError.message,
    });
    throw updateError;
  }
}
